<template>
  <payment-flow-animation
    :result="result"
    flow="card"
    :overlay="false"
    :success-action-label="actionLabel"
    :error-action-label="actionLabel"
    @action="goCards"
  />
</template>

<script>
import PaymentFlowAnimation from "@/components/payment/PaymentFlowAnimation";

export default {
  name: "CardCancel",
  components: {
    PaymentFlowAnimation,
  },
  computed: {
    cancelMessage() {
      return (
        this.$store.state.Payment.cardSaveResultMessage ||
        this.$t("pay.cardNotAdded")
      );
    },
    result() {
      return {
        success: false,
        message: this.cancelMessage,
      };
    },
    actionLabel() {
      if (this.$i18n && this.$i18n.locale === "en") return "To cards";
      if (this.$i18n && this.$i18n.locale === "ru") return "К картам";
      return "До карток";
    },
  },
  methods: {
    async goCards() {
      await this.$router.push({ name: "PaymentCards" });
    },
  },
};
</script>
